import { Box, FormControlLabel, FormHelperText, FormLabel, RadioGroup as MuiRadioGroup, Radio } from '@mui/material';
import FormControl from '@mui/material/FormControl';

type Props = {
  label?: string;
  value: string;
  options: any[];
  required?: boolean;
  disabled?: boolean;
  autoFocus?: boolean;
  fullWidth?: boolean;
  error?: string;
  direction?: 'row' | 'column';
  maxOptionsPerColumn?: number;
  onChange: (value: string) => void;
};

const RadioGroup = ({
  label,
  value,
  options = [],
  required,
  disabled,
  error,
  autoFocus,
  fullWidth = true,
  direction = 'column',
  maxOptionsPerColumn = 5,
  onChange,
}: Props) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  return (
    <FormControl fullWidth={fullWidth} sx={{ marginTop: 0 }}>
      {label && <FormLabel required={required}>{label}</FormLabel>}

      <Box sx={{ padding: '4px' }}>
        <MuiRadioGroup
          value={value}
          onChange={handleChange}
          autoFocus={autoFocus}
          row={direction === 'row'}
          sx={{
            display: options.length > maxOptionsPerColumn ? 'grid' : 'flex',
            gridAutoFlow: 'column',
            gridTemplateRows: options.length > maxOptionsPerColumn ? `repeat(${maxOptionsPerColumn}, auto)` : 'none',
            gap: 0,
          }}
        >
          {options.map((option: any) =>
            typeof option === 'string' ? (
              <FormControlLabel key={option} value={option} control={<Radio disabled={disabled} />} label={option} />
            ) : (
              <FormControlLabel
                key={option.value || option.label}
                value={option.value}
                control={<Radio disabled={disabled || option.disabled} />}
                label={option.label || option.value}
              />
            ),
          )}
        </MuiRadioGroup>
      </Box>
      {error && <FormHelperText error>{error}</FormHelperText>}
    </FormControl>
  );
};

export default RadioGroup;
